import {
  gridDensityValueSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid-pro";
import { useMemo, useState } from "react";
import { useLanguage } from "../../../../stores/LanguageStore";
import { Loader, Select } from "@mantine/core";
import { updateProfile } from "../../../../api/UserAPI";
import { useProfileStore } from "../../../../stores/UserStore";

const TableDensity = () => {
  const lang = useLanguage((s) => s.language);
  const apiRef = useGridApiContext();
  const [loading, setLoading] = useState(false);

  const options = useMemo(() => {
    return [
      { label: lang.table.toolbar.density.compact, value: "compact" },
      { label: lang.table.toolbar.density.standard, value: "standard" },
      { label: lang.table.toolbar.density.comfortable, value: "comfortable" },
    ];
  }, [lang]);

  const onChange = (newValue) => {
    const profile = useProfileStore.getState()?.profile;
    setLoading(true);
    updateProfile(profile?.id, {
      table_density: newValue,
    })
      .then((res) => {
        apiRef.current.setDensity(newValue);
        useProfileStore
          .getState()
          .setProfile({ ...profile, table_density: newValue });
      })
      .finally(() => setLoading(false));
  };

  const density = useGridSelector(apiRef, gridDensityValueSelector);

  return (
    <Select
      onChange={(newValue) => {
        onChange(newValue);
      }}
      required
      defaultValue={density}
      data={options}
      leftSection={loading ? <Loader size={16} /> : null}
      label={lang.table.toolbar.density.button_label}
      comboboxProps={{ zIndex: 1600, offset: 1 }}
    />
  );
};

export default TableDensity;
